<template>
    <div>
        <div class="profile-style mb-5 pb-5">
            <h5 class="mb-4">Page Setting</h5>

            <ValidationObserver ref="form">
                <div v-for="data in page_setting" :class="[{ 'active' : active_page === data.id}]" class="mb-3 drag-gallery position-relative" :key="data.id" >
                    <div class="link" @click="openPages(data.id)"  :class="[{ 'active' : active_page === data.id}]">
                        <div class="link-body">
                            <div class="link-content">
                                <div class="link-item pr-5">
                                    <div><strong>{{data.name}}</strong></div>
                                </div>
                                <div class="link-switch d-flex" v-on:click.stop="">
                                    <a href="#" v-on:click.prevent="openPages(data.id)" class="act m-0">
                                        <i :class="[active_page === data.id ? 'uil uil-angle-up' : 'uil uil-angle-down']"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                
                    </div>
                    <div class="gallery-wrapper" v-on:click.stop="">

                        <template v-if="active_page === '1'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="website.is_cover" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Cover Display</strong></span>
                                    <p class="desc">This function is used to hide or showing cover on website</p>
                                </label>
                            </div>

                            <validation-provider v-if="!website.cover_image" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                                <div class="form-group mt-3">
                                    <div class="mb-1">
                                        <label>Cover Image</label>
                                    </div>
                                    <div class="btn-up d-flex align-items-center" @click="clickUploadImage('cover_image')">
                                        <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                    </div>
                                    <input ref="cover_image" 
                                            type="file"
                                            class="custom-file-input d-none"
                                            id="Thumbnail"
                                            v-on:change="onImageUpload($event,'cover_image')"
                                            accept="image/jpeg,image/png,image/jpg" 
                                            @input="validate" >
                
                                    <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                            
                            <div class="form-group mt-3" v-if="website.cover_image">   
                                <div class="mb-1">
                                    <label>Cover Image</label>
                                </div> 
                                <button v-on:click.prevent="removeImageUpload('cover_image')" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                                <div class="input-group img-sh">
                                    <img :src="website.cover_image" class="w-50 img-responsive img-prf">
                                </div>
                            </div>

                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Cover Title</label>
                                    <input v-model="website.cover_title" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                    <small>Use [text] for mare different color on text in cover title</small>
                                </div>
                            </validation-provider>
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Cover Description</label>
                                    <editor
                                        v-model="website.cover_desc"
                                        :api-key="api_tiny"
                                        :init="EditorOptions"
                                    />
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                            <div class="row">
                                <div class="col-md-6">
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Cover Button Text 1</label>
                                            <input v-model="website.cover_btn1_text" type="text" class="form-control" name="categories">
                                            <div class="invalid-input">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>
                                </div>
                                <div class="col-md-6">
                                    <validation-provider rules="required|url" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Cover Button Link 1</label>
                                            <input v-model="website.cover_btn1_link" type="text" class="form-control" name="categories">
                                            <div class="invalid-input">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>
                                </div>
                                <div class="col-md-6">
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Cover Button Text 2</label>
                                            <input v-model="website.cover_btn2_text" type="text" class="form-control" name="categories">
                                            <div class="invalid-input">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>
                                </div>
                                <div class="col-md-6">
                                    <validation-provider rules="required|url" v-slot="{ errors }">
                                        <div class="form-group">
                                            <label>Cover Button Link 2</label>
                                            <input v-model="website.cover_btn2_link" type="text" class="form-control" name="categories">
                                            <div class="invalid-input">{{ errors[0] }}</div>
                                        </div>
                                    </validation-provider>
                                </div>
                            </div>

                            <div class="text-right">
                                <button v-on:click="validationForm('cover')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Settings
                                </button>
                            </div>
                        </template>

                        <template v-if="active_page === '2'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="website.is_about" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>About Display</strong></span>
                                    <p class="desc">This function is used to hide or showing about on website</p>
                                </label>
                            </div>
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>About Title</label>
                                    <input v-model="website.about_title" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                    <small>Use [text] for mare different color on text in about title</small>
                                </div>
                            </validation-provider>
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>About Description</label>
                                    <editor
                                        v-model="website.about_desc"
                                        :api-key="api_tiny"
                                        :init="EditorOptions"
                                    />
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <h5>About Us Item List</h5>
                            <div class="row">
                                <div class="col-md-6">
                                     <div class="form-group">
                                        <label>Item Title 1</label>
                                        <input v-model="website.about_item_title1" type="text" class="form-control" name="categories">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                     <div class="form-group">
                                        <label>Description Item 1</label>
                                        <input v-model="website.about_item_desc1" type="text" class="form-control" name="categories">
                                    </div>
                                </div>
                                 <div class="col-md-6">
                                     <div class="form-group">
                                        <label>Item Title 2</label>
                                        <input v-model="website.about_item_title2" type="text" class="form-control" name="categories">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                     <div class="form-group">
                                        <label>Description Item 2</label>
                                        <input v-model="website.about_item_desc2" type="text" class="form-control" name="categories">
                                    </div>
                                </div>
                                 <div class="col-md-6">
                                     <div class="form-group">
                                        <label>Item Title 3</label>
                                        <input v-model="website.about_item_title3" type="text" class="form-control" name="categories">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                     <div class="form-group">
                                        <label>Description Item 3</label>
                                        <input v-model="website.about_item_desc3" type="text" class="form-control" name="categories">
                                    </div>
                                </div>
                                 <div class="col-md-6">
                                     <div class="form-group">
                                        <label>Item Title 4</label>
                                        <input v-model="website.about_item_title4" type="text" class="form-control" name="categories">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                     <div class="form-group">
                                        <label>Description Item 4</label>
                                        <input v-model="website.about_item_desc4" type="text" class="form-control" name="categories">
                                    </div>
                                </div>
                            </div>

                            <div class="text-right">
                                <button v-on:click="validationForm('about')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Settings
                                </button>
                            </div>
                        </template>

                        <template v-if="active_page === '3'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="website.is_featured" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Featured Display</strong></span>
                                    <p class="desc">This function is used to hide or showing featured on website</p>
                                </label>
                            </div>

                            <validation-provider v-if="!website.featured_image" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                                <div class="form-group mt-3">
                                    <div class="mb-1">
                                        <label>Featured Image</label>
                                    </div>
                                    <div class="btn-up d-flex align-items-center" @click="clickUploadImage('featured_image')">
                                        <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                                    </div>
                                    <input ref="featured_image" 
                                            type="file"
                                            class="custom-file-input d-none"
                                            id="Thumbnail"
                                            v-on:change="onImageUpload($event,'featured_image')"
                                            accept="image/jpeg,image/png,image/jpg" 
                                            @input="validate" >
                
                                    <div class="invalid-input mt-3">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>
                            
                            <div class="form-group mt-3" v-if="website.featured_image">   
                                <div class="mb-1">
                                    <label>Featured Image</label>
                                </div> 
                                <button v-on:click.prevent="removeImageUpload('featured_image')" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                                <div class="input-group img-sh">
                                    <img :src="website.featured_image" class="w-50 img-responsive img-prf">
                                </div>
                            </div>

                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Featured Title</label>
                                    <input v-model="website.featured_title" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                    <small>Use [text] for mare different color on text in featured title</small>
                                </div>
                            </validation-provider>
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Featured Description</label>
                                    <editor
                                        v-model="website.featured_desc"
                                        :api-key="api_tiny"
                                        :init="EditorOptions"
                                    />
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <div class="text-right">
                                <button v-on:click="validationForm('featured')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Settings
                                </button>
                            </div>
                        </template>

                        <template v-if="active_page === '4'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="website.is_tema" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Tema List Display</strong></span>
                                    <p class="desc">This function is used to hide or showing tema on website</p>
                                </label>
                            </div>
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Tema Title</label>
                                    <input v-model="website.tema_title" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                    <small>Use [text] for mare different color on text in tema title</small>
                                </div>
                            </validation-provider>
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Tema Description</label>
                                    <editor
                                        v-model="website.tema_desc"
                                        :api-key="api_tiny"
                                        :init="EditorOptions"
                                    />
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <div class="text-right">
                                <button v-on:click="validationForm('tema')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Settings
                                </button>
                            </div>
                        </template>

                        <template v-if="active_page === '5'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="website.is_pricelist" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Pricelist Display</strong></span>
                                    <p class="desc">This function is used to hide or showing pricelist on website</p>
                                </label>
                            </div>
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Pricelist Title</label>
                                    <input v-model="website.pricelist_title" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                    <small>Use [text] for mare different color on text in pricelist title</small>
                                </div>
                            </validation-provider>
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Pricelist Description</label>
                                    <editor
                                        v-model="website.pricelist_desc"
                                        :api-key="api_tiny"
                                        :init="EditorOptions"
                                    />
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <div class="text-right">
                                <button v-on:click="validationForm('pricelist')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Settings
                                </button>
                            </div>
                        </template>

                          <template v-if="active_page === '6'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="website.is_testimonial" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>Testimonial Display</strong></span>
                                    <p class="desc">This function is used to hide or showing testimonial on website</p>
                                </label>
                            </div>
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Testimonial Title</label>
                                    <input v-model="website.testimonial_title" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                    <small>Use [text] for mare different color on text in faq title</small>
                                </div>
                            </validation-provider>
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Testimonial Description</label>
                                    <editor
                                        v-model="website.testimonial_desc"
                                        :api-key="api_tiny"
                                        :init="EditorOptions"
                                    />
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <div class="text-right">
                                <button v-on:click="validationForm('testimonial')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Settings
                                </button>
                            </div>
                        </template>

                        <template v-if="active_page === '7'">
                            <div class="d-flex">
                                <label class="pl-0 custom-switch switch-big">
                                    <input v-model="website.is_faq" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                    <span class="custom-switch-indicator"></span>
                                </label>
                                <label class="mt-3 ml-3">
                                    <span class="custom-switch-description ml-0"><strong>FAQ Display</strong></span>
                                    <p class="desc">This function is used to hide or showing faq on website</p>
                                </label>
                            </div>
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>FAQ Title</label>
                                    <input v-model="website.faq_title" type="text" class="form-control" name="categories">
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                    <small>Use [text] for mare different color on text in faq title</small>
                                </div>
                            </validation-provider>
                            <validation-provider rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>FAQ Description</label>
                                    <editor
                                        v-model="website.faq_desc"
                                        :api-key="api_tiny"
                                        :init="EditorOptions"
                                    />
                                    <div class="invalid-input">{{ errors[0] }}</div>
                                </div>
                            </validation-provider>

                            <div class="text-right">
                                <button v-on:click="validationForm('faq')" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                                    Save Settings
                                </button>
                            </div>
                        </template>
                      
                    </div>
                </div>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    import {ValidationProvider, ValidationObserver, extend } from "vee-validate";
    import options from "../../../../utils/editor";
    import Editor from '@tinymce/tinymce-vue'
    // import draggable from 'vuedraggable'

    extend('youtube', {
        message: 'Url Youtube not valid',
        validate: value => /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/.test(value),
    });

    export default{
        data(){
            return{
                api_tiny:process.env.VUE_APP_TINYKEY,
                EditorOptions: options.Options,
                loading:false,
                active_page:'',
                drag_nav:false,
                page_setting:[
                    {id:'1',name:'Cover'},
                    {id:'2',name:'About Us'},
                    {id:'3',name:'Featured'},
                    {id:'4',name:'Tema'},
                    {id:'5',name:'Pricelist'},
                    {id:'6',name:'Testimonial'},
                    {id:'7',name:'Faq'},
                ],

                cover_image:'',
                featured_image:'',
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            Editor,
            // draggable,
        },
        computed: {
            ...mapState('WebsiteControl', {
                website: state => state.website,
            }),
           
        },
        methods:{
            ...mapActions('WebsiteControl', ['getWebsite','updateSettings']),
            
            openPages: function(id){
                if(id == this.active_page){
                    this.active_page = ''
                }else{
                    this.active_page = id
                }
            },
            clickUploadImage:function(type){
                this.$refs[type][0].click()
            },
            onImageUpload: function(event,type) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.website[type] = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this[type] = input.files[0]
            },
            removeImageUpload:function(type){
                 this[type] = ''
                 this.website[type] = ''
            },

            validationForm: function(type) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                       
                        if(type == 'cover'){
                            formData.append('is_cover', this.website.is_cover);
                            formData.append('cover_title', this.website.cover_title ? this.website.cover_title : '');
                            formData.append('cover_desc', this.website.cover_desc ? this.website.cover_desc : '');
                            formData.append('cover_btn1_link', this.website.cover_btn1_link ? this.website.cover_btn1_link : '');
                            formData.append('cover_btn1_text', this.website.cover_btn1_text ? this.website.cover_btn1_text : '');
                            formData.append('cover_btn2_link', this.website.cover_btn2_link ? this.website.cover_btn2_link : '');
                            formData.append('cover_btn2_text', this.website.cover_btn2_text ? this.website.cover_btn2_text : '');
                            formData.append('cover_image_file', this.cover_image);
                            formData.append('cover_image', this.website.cover_image ? this.website.cover_image : '');
                        }
                        else if(type == 'about'){
                            formData.append('is_about', this.website.is_about);
                            formData.append('about_title', this.website.about_title ? this.website.about_title : '');
                            formData.append('about_desc', this.website.about_desc ? this.website.about_desc : '');
                            formData.append('about_item_title1', this.website.about_item_title1 ? this.website.about_item_title1 : '');
                            formData.append('about_item_title2', this.website.about_item_title2 ? this.website.about_item_title2 : '');
                            formData.append('about_item_title3', this.website.about_item_title3 ? this.website.about_item_title3 : '');
                            formData.append('about_item_title4', this.website.about_item_title4 ? this.website.about_item_title4 : '');
                            formData.append('about_item_desc1', this.website.about_item_desc1 ? this.website.about_item_desc1 : '');
                            formData.append('about_item_desc2', this.website.about_item_desc2 ? this.website.about_item_desc2 : '');
                            formData.append('about_item_desc3', this.website.about_item_desc3 ? this.website.about_item_desc3 : '');
                            formData.append('about_item_desc4', this.website.about_item_desc4 ? this.website.about_item_desc4 : '');
                        }
                        else if(type == 'featured'){
                            formData.append('is_featured', this.website.is_featured);
                            formData.append('featured_title', this.website.featured_title ? this.website.featured_title : '');
                            formData.append('featured_desc', this.website.featured_desc ? this.website.featured_desc : '');
                            formData.append('featured_image_file', this.featured_image);
                            formData.append('featured_image', this.website.featured_image ? this.website.featured_image : '');
                        }
                        else if(type == 'tema'){
                            formData.append('is_tema', this.website.is_tema);
                            formData.append('tema_title', this.website.tema_title ? this.website.tema_title : '');
                            formData.append('tema_desc', this.website.tema_desc ? this.website.tema_desc : '');
                        }
                        else if(type == 'pricelist'){
                            formData.append('is_pricelist', this.website.is_pricelist);
                            formData.append('pricelist_title', this.website.pricelist_title ? this.website.pricelist_title : '');
                            formData.append('pricelist_desc', this.website.pricelist_desc ? this.website.pricelist_desc : '');
                        }
                        else if(type == 'testimonial'){
                            formData.append('is_testimonial', this.website.is_testimonial);
                            formData.append('testimonial_title', this.website.testimonial_title ? this.website.testimonial_title : '');
                            formData.append('testimonial_desc', this.website.testimonial_desc ? this.website.testimonial_desc : '');
                        }
                        else if(type == 'faq'){
                            formData.append('is_faq', this.website.is_faq);
                            formData.append('faq_title', this.website.faq_title ? this.website.faq_title : '');
                            formData.append('faq_desc', this.website.faq_desc ? this.website.faq_desc : '');
                        }


                        formData.append("type", type);
                        formData.append("_method", "put");

                        this.updateSettings(formData).then(() => {
                            this.loading = false
                            this.cover_image = ''
                            this.getWebsite(this.$route.params.id)
                            this.$toast.success('Successfully Update Settings')
                        }).catch((error) => {
                            console.log(error)
                            this.loading = false
                            this.$toast.warning('Sorry, Something Error')
                        })

                    }
                });
            },
        }
    }

</script>

<style scoped>
    .btn-image-remove{
        padding: 0px 15px;
    }
</style>